homeFaqs = {
    initItem: function (item, open) {
        var button = item.find(".faqs-item__label");
        var panel = item.find(".faqs-item__body");
        var inner = item.find(".faqs-item__body-inner");

        item.toggleClass("open", open);
        button.attr("aria-expanded", open);
        panel.height(open ? inner.outerHeight() : 0);
    },

    bind: function (section) {
        var self = this;
        var items = section.find(".faqs-item");

        items.each(function (index) {
            var item = $(this);
            var button = item.find(".faqs-item__label");
            var panel = item.find(".faqs-item__body");
            var panelId = "FaqPanel-" + section.index() + "-" + index;

            panel.attr("id", panelId);
            button.attr("aria-controls", panelId);
            self.initItem(item, false);
        });

        section.find(".faqs-item__label").off("click.homeFaqs").on("click.homeFaqs", function () {
            var item = $(this).closest(".faqs-item");
            self.initItem(item, !item.hasClass("open"));
        });
    },

    init: function () {
        var self = this;

        $(".section-faqs").each(function () {
            self.bind($(this));
        });

        $(window).off("resize.homeFaqs").on("resize.homeFaqs", function () {
            $(".faqs-item.open").each(function () {
                var item = $(this);
                item.find(".faqs-item__body").height(item.find(".faqs-item__body-inner").outerHeight());
            });
        });
    }
};

$(document).ready(function () {
    homeFaqs.init();
});
